import { useMemo } from 'react';

function useAutoLinker(actionNotes: string) {

    return useMemo(() => {
        const replaceWithLink = () => {
            if (!actionNotes) return actionNotes;
            let regex = /\[\[(?:<[\w\sa-z0-9="'();\-:]*)*(?:>)*(?:\s)?([0-9]+)(?:\s)?(?:<\/\w*>)*\]\]/g;
            let text = actionNotes.replace(regex, (match, p1) => {
                return `<a class="Ticket-Link" href="./ticket/${p1}">${p1}</a>`;
            });
            regex = /\[\[KB([0-9]+)\]\]/ig;
            text = text.replace(regex, (match, p1) => {
                return `<a class="KB-Link" href="./KBase/Default.aspx?KB_Id=${p1}">KB${p1}</a>`;
            });

            regex = /\[\[(@[a-z,A-Z,0-9, ]+)\]\]/ig;
            return text.replace(regex, (match, p1) => {
                return `<span class="Tag-Link">${p1}</span>`;
            });
        };

        return replaceWithLink;
    }, [actionNotes]);
}

export default useAutoLinker;